import Component from '@glimmer/component';

export default class MwGroupSidebarRight extends Component {}
